import { Content, PageWithHeader } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { useLocation } from 'react-router';
import { SearchResultList } from '@appfolio/backstage-plugin-search';

export const NotFound = ({ query }: { query: string }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <SearchResultList query={query} />
      </Grid>
    </Grid>
  );
};

export const NotFoundErrorPage = () => {
  const location = useLocation();
  const query = Array.from(
    new Set(
      `${location.pathname} ${location.search} ${location.hash}`
        .replace(/[/?&#=]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' '),
    ),
  ).join(' ');
  return (
    <PageWithHeader
      themeId="app"
      title="Not Found"
      subtitle="Looks like that page is missing. Try adjusting the URL or take a look at these related results."
    >
      <Content>
        <NotFound query={query} />
      </Content>
    </PageWithHeader>
  );
};
